// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2GtJu","col":"CardReaderDesc_col__hsNRC","label":"CardReaderDesc_label__2x7N4"};